var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSrories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#012169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2308 13.92C12.8281 14.5342 13.7901 15.5068 15.0001 17.0001M11.2308 13.92C9.28683 13.1726 7.82495 12.9777 6.50006 13.0001M11.2308 13.92C12.7453 12.2543 13.7409 11.053 17.5001 10.5001",
    stroke: "#012169",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10H10.001",
    stroke: "#012169",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6,
    stroke: "#012169",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 13.4222 21.7031 14.7751 21.1679 16M12 22C13.4222 22 14.7751 21.7031 16 21.1679C17.1534 20.664 18.1934 19.9487 19.0711 19.0711M2 12C2 10.5778 2.2969 9.22492 2.83209 8C3.33605 6.84656 4.0513 5.80656 4.92893 4.92893M12 2C10.5778 2 9.22492 2.2969 8 2.83209M8 21.1679C6.84656 20.664 5.80656 19.9487 4.92893 19.0711C4.0513 18.1934 3.33605 17.1534 2.83209 16M15.8321 3C16.9855 3.50396 18.0255 4.21922 18.9032 5.09685C19.7808 5.97447 20.496 7.01447 21 8.16792",
    stroke: "#012169",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrories);
export default __webpack_public_path__ + "static/media/srories.48fda8ef4cd0b045474199e1560d08bf.svg";
export { ForwardRef as ReactComponent };